var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartScatter",staticStyle:{"width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }